import React, {ReactNode} from 'react';
import styles from './PageHeader.module.css';
import {BackButton} from "../../shared/buttons/BackButton";
import {KBBreadcrumbs} from "../Breadcrumbs/KBBreadcrumbs";
import {IFolder} from "../../../types/knowledgeBase.types";

interface PageHeaderProps {
    title: string;
    buttons: ReactNode;
    isRootLevel: boolean
    isAdmin:boolean;
    currentFolder?: IFolder;
}

export const PageHeader: React.FC<PageHeaderProps> = ({
                                                          title,
                                                          buttons,
                                                          isRootLevel,
                                                          isAdmin,
                                                          currentFolder
                                                      }) => {

    return (

            <div className={styles.header}>
                {!isRootLevel && (
                    <BackButton className={styles.backBtn}/>
                )}
                {!isRootLevel && (
                    <KBBreadcrumbs folder={currentFolder} isAdmin={isAdmin}/>
                )}
                <div className={styles.headerTop}>

                    <h1 className={styles.title}>{title}</h1>
                    <div className={styles.buttonsContainer}>
                        {buttons}
                    </div>
                </div>

            </div>

    );
};
